import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  root: {
    paddingLeft: "1rem",
    "@media(max-width: 700px)": {
      paddingLeft: 0,
    },
  },
  formBody: {
    width: "100%",
    maxWidth: "1200px",
    paddingLeft: "2rem",
    paddingRight: "3rem",
    paddingBottom: "3rem",
    paddingTop: "2rem",
    backgroundColor: "#fff",
    borderTopLeftRadius: "25px",
    borderTopRightRadius: "25px",
    borderBottomLeftRadius: "25px",
    borderBottomRightRadius: "25px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    marginBottom: "3rem",
  },
  subContainer: {
    paddingLeft: "1rem",
    paddingRight: "1rem",
    "& .ms-TextField-fieldGroup": {
      height: "42px",
      ...shorthands.borderRadius("8px"),
    },
    "& .ms-Dropdown-title": {
      height: "42px",
      lineHeight: "40px",
      ...shorthands.borderRadius("8px"),
    },
    "& .ms-Dropdown-caretDownWrapper": {
      height: "42px",
      lineHeight: "42px",
    },
    "& .ms-TextField-field": {
      fontSize: "0.95rem",
    },
  },
  sectionTitle: {
    marginTop: "1.5rem",
    marginBottom: "0.5rem",
    paddingBottom: "0.5rem",
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    borderBottomColor: "#edebe9",
  },
  mb8: {
    marginBottom: "1rem",
  },
  fieldErrorText: {
    color: "#a80000",
    fontSize: "0.75rem",
    marginTop: "-0.75rem",
    marginBottom: "0.75rem",
  },
  fieldHintTextPositive: {
    color: "#107c10",
    fontSize: "0.75rem",
    marginTop: "-0.75rem",
    marginBottom: "0.75rem",
  },
  fieldHintTextMuted: {
    color: "#605e5c",
    fontSize: "0.75rem",
    marginTop: "-0.75rem",
    marginBottom: "0.75rem",
  },
  fieldRow: {
    display: "flex",
    columnGap: "1.5rem",
    flexWrap: "wrap",
  },
  fieldRowItem: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "320px",
  },
  toggleRow: {
    marginBottom: "1rem",
    alignItems: "flex-start",
  },
  errorBanner: {
    marginTop: "1rem",
    marginBottom: "1rem",
    paddingTop: "0.75rem",
    paddingBottom: "0.75rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
    borderBottomLeftRadius: "6px",
    borderBottomRightRadius: "6px",
    backgroundColor: "#fde7e9",
    color: "#a80000",
  },
  notice: {
    marginTop: "0.5rem",
    marginBottom: "1rem",
    paddingTop: "0.75rem",
    paddingBottom: "0.75rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
    borderBottomLeftRadius: "6px",
    borderBottomRightRadius: "6px",
    backgroundColor: "#fff4ce",
    color: "#8a6d00",
  },
  successBanner: {
    marginTop: "0.5rem",
    marginBottom: "1.5rem",
    paddingTop: "0.75rem",
    paddingBottom: "0.75rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
    borderBottomLeftRadius: "6px",
    borderBottomRightRadius: "6px",
    backgroundColor: "#dff6dd",
    color: "#107c10",
  },
  btnContainer: {
    marginTop: "2rem",
    display: "flex",
    columnGap: "10px",
    "& .ms-Button": {
      ...shorthands.borderRadius("8px"),
    },
  },
  fieldRowSpaced: {
    marginTop: "1rem",
  },
});
